import { Typography, Grid, Box, IconButton } from "@mui/material";
import { add, format, differenceInCalendarDays, isFuture } from "date-fns";
import React, { PureComponent, useEffect, useState } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart, Line, Cell, ZAxis } from 'recharts';
import { calculateColorGradientValue } from "../../utils/scatterColor";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const dateFormatter = (date: any) => {
  return format(new Date(date), "yyyy-MM");
};

interface CustomScatterChartProps {
  dashboardData: any,
  lowColor: string,
  highColor: string,
  dataValueForLowColor: number,
  dataValueForHighColor: number,
  defaultColor: string,
  type: string,
  title: string,
  setInfoPopup: Function
}

export default function CustomScatterChart({
  dashboardData,
  lowColor,
  highColor,
  dataValueForLowColor,
  dataValueForHighColor,
  defaultColor,
  type,
  title,
  setInfoPopup }: CustomScatterChartProps) {

  function getTicks(month: number) {
    /**
     * Extract ticks for chosen 
     * @var month
     * comment: First month of year does not exist on whole timeperiod
     */
    const ticks: any[] = []
    dashboardData.forEach(function (item: any, index: any) {
      if (new Date(item.date).getMonth() === month) {
        ticks.push(item.date)
      }
    })
    return ticks
  }
  const ticks = getTicks(7)

  const [dashboardDataWithColor, setDashboardDataWithColor] = useState<any>([])

  function handleInfoClick(type: string) {
    setInfoPopup({
      open: true,
      id: type,
      title: title
    })
  }


  useEffect(() => {
    /**
     * Add color for each scatter point
     */
    let dataWithColor: any[]
    dataWithColor = []
    dashboardData.forEach(function (item: any, index: any) {
      dataWithColor.push({
        date: item.date,
        value: item.value,
        trend: item.trend,
        // color: calculateColorGradientValue("#D14343", "#65C18C", 0, 1, item.value, "#65C18C")
        color: calculateColorGradientValue(lowColor, highColor, dataValueForLowColor, dataValueForHighColor, item.value, defaultColor)
      })
    })
    setDashboardDataWithColor(dataWithColor)
  }, [dashboardData])



  return (
    //https://github.com/recharts/recharts/issues/1156
    // Add a centered Typography tag above chart with type h5
      <>
        <Grid container justifyContent="center" alignItems="center">

          <Typography variant="body2" align="center">
            <Box fontWeight='fontWeightMedium' display='inline'>
              {title}
            </Box>
          </Typography>
          <Grid item >
            <IconButton sx={{ padding: 0, pl: 1, pb: 0.2 }} onClick={() => handleInfoClick(type)} >
              <InfoOutlinedIcon />
            </IconButton>
          </Grid>
        </Grid>

        <ResponsiveContainer width="99%" aspect={3.6} maxHeight={160} >

          <ComposedChart

            // key={showGraph}
            data={dashboardDataWithColor}
            // width={1000}
            // height={300}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: -30,
            }} >
            <ZAxis range={[30, 31]}
            //changes size of dots
            />
            <XAxis
              tickFormatter={dateFormatter}
              ticks={ticks}
              dataKey="date"
              type="number"
              domain={['dataMin', 'dataMax']}
              padding={{ left: 10, right: 10 }} />
            <YAxis type="number"
              tickFormatter={(tick: any) => tick.toLocaleString('de-DE')}
              domain={[0, 1]}
              ticks={[0, 0.5, 1]}
            />
            <Scatter dataKey="value" fill="#8884d8">
              {dashboardDataWithColor.map((entry: any, index: any) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Scatter>

            <Tooltip
              formatter={(value: any, name: any) => (Math.round(value * 100) / 100).toLocaleString("DE")}
              labelFormatter={() => type}
            />

            <Line dot={false} strokeDasharray="4" dataKey="trend" stroke="black" isAnimationActive={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </>
  );
}

